import { useIntl } from 'react-intl'

import ConfirmationDetails from '../Common/ConfirmationDetails'
import Divider from '../Common/Divider'
import ItemTypeAndBookedLabel from '../Common/ItemTypeAndBookedLabel'
import SummaryAdditionalNotes from '../Common/SummaryAdditionalNotes'
import SummaryDataItem from '../Common/SummaryDataItem'

import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import ModalContent from 'LuxKit/Modal/ModalContent'
import GooglePlaceRating from 'tripPlanner/components/GooglePlaceRating/GooglePlaceRating'
import AddressWithViewMapButton from 'tripPlanner/components/TripModal/TripItems/Summary/Common/AddressWithViewMapButton'
import CheckInAndOutDate from 'tripPlanner/components/TripModal/TripItems/Summary/Common/CheckInAndOutDate'
import type { AccommodationItem } from 'tripPlanner/types/tripItem'
import { maybePlaceId } from 'tripPlanner/utils'

interface Props {
  item: AccommodationItem
}

function CustomItemSummaryContent({ item }: Props) {
  const intl = useIntl()
  const haveAnyDates =
    item.startDate || item.endDate || item.startDay || item.endDay
  const placeId = maybePlaceId(item.place)
  return (
    <ModalContent>
      <VerticalSpacer gap={20}>
        <ItemTypeAndBookedLabel item={item} />
        {haveAnyDates && (
          <CheckInAndOutDate
            isAccommodation={false}
            startDate={item.startDate}
            startTime={item.startTime}
            endTime={item.endTime}
            endDate={item.endDate}
          />
        )}
        {item.place.address && (
          <AddressWithViewMapButton
            item={item}
            address={item.place.address}
          />
        )}
        {placeId && (
          <GooglePlaceRating
            size="M"
            placeId={placeId}
            label={intl.formatMessage({
              id: 'HtourU8Zbc3rVV-5Q1FZ',
              defaultMessage: 'Reviews',
              description: 'Label for Google reviews section in custom accommodation summary',
            })}
          />
        )}
        <ConfirmationDetails
          isBooked={item.isBooked}
          confirmationCode={item.confirmationCode}
          price={item.price}
        />
        <Divider />
        {item.url && (
          <SummaryDataItem
            title={intl.formatMessage({
              id: 'ZDMQCH15AV0ya18xDBgb',
              defaultMessage: 'Website',
              description: 'Label for website URL in custom accommodation summary',
            })}
            value={item.url}
            url={item.url}
          />
        )}
        {item.phone && (
          <SummaryDataItem
            title={intl.formatMessage({
              id: 'lhSZw0i5yMjEgEAsHh8m',
              defaultMessage: 'Phone number',
              description: 'Label for phone number in custom accommodation summary',
            })}
            value={item.phone}
            url={`tel:${item.phone}`}
          />
        )}
        {item.notes && <SummaryAdditionalNotes notes={item.notes} />}
      </VerticalSpacer>
    </ModalContent>
  )
}

export default CustomItemSummaryContent
